module.exports = __webpack_public_path__ + "static/media/magnet.1aaaf261.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/magnet.png
// module id = 330
// module chunks = 0